import { useCallback } from 'react';
import {
  Illustration,
  ClozeParagraphDragAndDrop,
  ClozeParagraphText,
  RichText,
  NestedList,
  ClozeTableText,
  DragAndDropImage,
  ClozeTableDragAndDrop,
  FileUploaderInput,
  Table,
  Image,
} from './components';
import { SafeHTML } from 'edrolo/domains/app';
import styles from './styles.scss';
import cx from 'classnames';
/* eslint-disable react/prop-types */ // TODO: add props

const Header = ({ blockData: { text, level } }) => {
  const Component = `h${level}`;
  return (
    <Component>
      <SafeHTML as="span">{text}</SafeHTML>
    </Component>
  );
};

const Paragraph = ({ blockData: { text } }) => (
  <p>
    <SafeHTML as="span">{text}</SafeHTML>
  </p>
);

const blockTypeMap = {
  paragraph: Paragraph,
  header: Header,
  list: NestedList,
  illustration: Illustration,
  table: Table,
  'rich-text': RichText,
  'cloze-paragraph-dnd': ClozeParagraphDragAndDrop,
  'cloze-paragraph-input': ClozeParagraphText,
  'cloze-table-text': ClozeTableText,
  'cloze-table-dnd': ClozeTableDragAndDrop,
  'image': Image,
  'file-upload': FileUploaderInput,
  'drag-and-drop-image': DragAndDropImage,
};

const inputBlockTypes = {
  illustration: 'Drawing response',
  'rich-text': 'Text response',
  'cloze-paragraph-input': 'Fill in the blank response',
  'cloze-paragraph-dnd': 'Fill in the blank response',
  'cloze-table-text': 'Fill in the table response',
  'cloze-table-dnd': 'Fill in the table response',
  'file-upload': 'File upload submission',
  'drag-and-drop-image': 'Drag and drop image response',
};

export const ActivityBlock = ({
  block,
  blockResponse,
  onBlockResponseChange,
  readOnly,
  showExample,
  reviewMode,
  activityResponseId,
}) => {
  const handleBlockUpdate = useCallback(
    (newBlockResponse) => {
      if (readOnly || showExample) {
        return;
      }
      onBlockResponseChange(block.id, newBlockResponse);
    },
    [block.id, onBlockResponseChange, readOnly, showExample]
  );

  if (reviewMode && !Object.keys(inputBlockTypes).includes(block.type)) {
    return null;
  }

  // for showExample mode we're passing the example response AS the blockResponse
  const blockResponseData = showExample
    ? block.data.example_response
    : blockResponse;

  const Component = blockTypeMap[block.type];

  if (!Component) {
    return <div>Unknown block {block.type}</div>;
  }

  return (
    <section
      data-test="activity-block"
      data-block-id={block.id}
      data-block-type={block.type}
      className={cx(styles.activityBlock, {
        [styles.reviewModeBlock]: reviewMode,
      })}
    >
      {!!reviewMode && <label>{inputBlockTypes[block.type]}</label>}

      <Component
        blockId={block.id}
        blockData={block.data}
        blockResponse={blockResponseData}
        onResponseChange={handleBlockUpdate}
        readOnly={readOnly}
        showExample={showExample}
        reviewMode={reviewMode}
        activityResponseId={activityResponseId}
      />
    </section>
  );
};
